export default "__VITE_ASSET__Czqxgx8t__"